'use es6';

import OpenApiSpecificationParser from '../../common/openApiSpecificationParser.js';
export default function parse(openApiSpecification, operationId, formData) {
  const parser = new OpenApiSpecificationParser(openApiSpecification);
  return parser.parse(operationId, formData || {});
}